<div id="electronic-billing-save-container" *ngIf="!this.loading; else loader">
  <div class="first" *ngIf="this.status.right != 0">
    <qr-icon name="check" color="success-600"></qr-icon>
    <p class="subheading-01-semi-bold">
      Se guardaron correctamente como borrador
      {{ this.status.right }} comprobantes.
    </p>
  </div>
  <div class="first" *ngIf="this.status.wrong != 0">
    <qr-icon name="error" color="error-700"></qr-icon>
    <p class="subheading-01-semi-bold">
      Se produjo un error guardando como borrador
      {{ this.status.wrong }} comprobantes.
    </p>
  </div>
  <p id="last" class="subheading-01-semi-bold">
    ¿Desea volver al listado principal o continuar con la solicitud del CAE a la
    Afip?
  </p>
</div>

<ng-template #loader>
  <div id="img-container">
    <mat-spinner [diameter]="50"></mat-spinner>
    <!-- El famoso PIKACHU de Beto -->
    <!-- <img
      src="https://media.tenor.com/DHGvsLhTOowAAAAC/meme-pikachu.gif"
      alt="lalala"
    /> -->
  </div>
</ng-template>
